import axios from "axios";
import { PickupPoint } from "../../../shared/map/models";

export const getPickupPointById = (id: string) => {
    return axios.get<PickupPoint>("PickupPoints/" + id);
} 